<template>
  <div class="scroll-top" :style="scrollTopStyle">
    <div class="icon-scroll-top" @click="goToTop">
      <i class="icon-triangle-arrow"></i>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'scroll-top',
  computed: {
    ...mapGetters('auth', [
      'LOCALE'
    ]),
    showScrollTop() {
      //Removing the ScrollTop block when we reach the main-footer
      if (this.currentScrollTop > document.documentElement.offsetHeight - 550) {
        return false;
      }
      return this.currentScrollTop > 300;
    },
    scrollTopStyle(){
      return this.showScrollTop ? {opacity: 1} : {opacity: 0, display: 'none'};
    }
  },
  beforeMount() {
    if (this.webview && window.flutter_inappwebview) {
      window.flutter_inappwebview.postMessage(
          JSON.stringify({
            type: 'true',
            actionType: 'update-locale',
            data: {
              key: 'locale',
              value: this.LOCALE,
              domain: `.${process.env.VUE_APP_DOMAIN}`,
            },
          })
      );
    }
  },
  methods: {
    goToTop() {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  }
}
</script>
